import { combineReducers } from '@reduxjs/toolkit';
import companies from './slices/company';
import reviews from './slices/reviews';
import locations from './slices/location';
import prompts from './slices/prompts';
import log from './slices/logs';
import topics from './slices/topics';
import facts from './slices/facts';
import brandVoice from './slices/brandVoice';
import pipelines from './slices/pipelines';
import snackbar from './slices/snackbar';
import filters from './slices/fliters'
import localFalcon from './slices/localFalcon'
import rolePermissions from './slices/rolePermissions';
import gmb from './slices/gmb';
import intercom from './slices/intercom';
import local from './slices/local';

const allReducers = combineReducers({
    companies: companies,
    reviews:reviews,
    masterData: locations,
    prompts:prompts,
    log:log,
    topics: topics,
    facts: facts,
    brandVoice: brandVoice,
    pipelines:pipelines,
    snackbar:snackbar,
    filters:filters,
    localFalcon: localFalcon,
    rolePermissions: rolePermissions,
    intercom: intercom,
    gmb: gmb,
    local: local
});
const rootReducer = (state, action) => {
    return allReducers(state, action);
}
export default rootReducer;
